export default __webpack_public_path__ + "static/media/003-barber shop.9da15f3b.svg";